import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout" }
const _hoisted_2 = { class: "layout__wrapper" }
const _hoisted_3 = { class: "title-section" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "title-section__title" }

import { onMounted } from 'vue'

import Sidebar from '@/app/components/doc/reading/Sidebar.vue'
import HeaderDoc from '@/app/components/doc/Header.vue'
import BackLink from '@/app/components/BackLink.vue'

import SidebarTOC from '@/app/components/doc/reading/SidebarTOC.vue'
import SidebarTutorial from '@/app/components/doc/tutorial/SidebarTutorial.vue'
import Tutorial from '@/app/components/doc/tutorial/Tutorial.vue'
import ContentLabel from '@/app/components/doc/ContentLabel.vue'
import UpgradePromptModal from '@/app/components/UpgradePromptModal.vue'

import { autoShowTutorial } from '@/models/doc.tutorial'
import type { DocView } from '@/models/doc'


export default /*@__PURE__*/_defineComponent({
  __name: 'Layout',
  props: {
    doc: {},
    showTextControls: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props

onMounted(() => {
  autoShowTutorial(props.doc.tutorial)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderDoc, { doc: __props.doc }, null, 8, ["doc"]),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "banner"),
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "page-title", {}, () => [
            _createElementVNode("h1", _hoisted_5, _toDisplayString(__props.doc.title), 1),
            (__props.doc.showAiLabel)
              ? (_openBlock(), _createBlock(ContentLabel, {
                  key: 0,
                  class: "doc-preview__content-label"
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("section", {
        class: _normalizeClass(["book-reading background-section", __props.doc.readingCssClass])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass([__props.doc.controls.containerClass, "container book-reading__content control-container"])
        }, [
          _createVNode(BackLink, { class: "book-reading__backlink" }),
          _createVNode(Sidebar, {
            doc: __props.doc,
            "show-text-controls": __props.showTextControls
          }, {
            default: _withCtx(() => [
              _createVNode(SidebarTOC, {
                doc: __props.doc,
                class: _normalizeClass(__props.doc.tutorial ? __props.doc.tutorial.tocBtnClass : '')
              }, null, 8, ["doc", "class"]),
              (__props.doc.tutorial && __props.doc.isCurrentFirstPage())
                ? (_openBlock(), _createBlock(SidebarTutorial, {
                    key: 0,
                    "book-tutorial": __props.doc.tutorial
                  }, null, 8, ["book-tutorial"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["doc", "show-text-controls"]),
          _renderSlot(_ctx.$slots, "page-content")
        ], 2),
        (__props.doc.tutorial && __props.doc.isCurrentFirstPage())
          ? (_openBlock(), _createBlock(Tutorial, {
              key: 0,
              "book-tutorial": __props.doc.tutorial
            }, null, 8, ["book-tutorial"]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "page-footer")
      ], 2)
    ]),
    _createVNode(UpgradePromptModal)
  ]))
}
}

})